import { ResponseError } from "./gen/runtime";

export async function otpRetryAt(error: unknown): Promise<Date | undefined> {
  if (!(error instanceof ResponseError)) return undefined;

  try {
    const body: unknown = await error.response.json();
    if (!body || typeof body !== "object" || !("retry_at" in body)) return undefined;
    const value = body.retry_at;
    if (typeof value !== "string") return undefined;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? undefined : date;
  } catch {
    return undefined;
  }
}

export function otpWaitSeconds(retryAt: Date | undefined, now: number): number {
  return retryAt ? Math.max(0, Math.ceil((retryAt.getTime() - now) / 1000)) : 0;
}

export function formatOTPWait(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, "0")}`;
}
